/**
 * Gamification Redux Actions
 * 
 * Azioni per gestire lo stato della gamification in Redux
 */

// Action Types
export const GAMIFICATION_TYPES = {
  SET_PROFILE: 'GAMIFICATION_SET_PROFILE',
  SET_LOADING: 'GAMIFICATION_SET_LOADING',
  SET_ERROR: 'GAMIFICATION_SET_ERROR',
  RECORD_EVENT_START: 'GAMIFICATION_RECORD_EVENT_START',
  RECORD_EVENT_SUCCESS: 'GAMIFICATION_RECORD_EVENT_SUCCESS',
  RECORD_EVENT_FAILURE: 'GAMIFICATION_RECORD_EVENT_FAILURE',
  SHOW_POINTS_TOAST: 'GAMIFICATION_SHOW_POINTS_TOAST',
  HIDE_POINTS_TOAST: 'GAMIFICATION_HIDE_POINTS_TOAST',
  SET_MODAL_VISIBLE: 'GAMIFICATION_SET_MODAL_VISIBLE',
  CLEAR_PROFILE: 'GAMIFICATION_CLEAR_PROFILE',
  START_STEP_ONBOARDING: 'GAMIFICATION_START_STEP_ONBOARDING',
  NEXT_STEP_ONBOARDING: 'GAMIFICATION_NEXT_STEP_ONBOARDING',
  END_STEP_ONBOARDING: 'GAMIFICATION_END_STEP_ONBOARDING'
};

/**
 * Imposta il profilo gamification
 */
export const setGamificationProfile = (profile) => ({
  type: GAMIFICATION_TYPES.SET_PROFILE,
  payload: profile
});

/**
 * Imposta lo stato di loading
 */
export const setGamificationLoading = (isLoading) => ({
  type: GAMIFICATION_TYPES.SET_LOADING,
  payload: isLoading
});

/**
 * Imposta un errore
 */
export const setGamificationError = (error) => ({
  type: GAMIFICATION_TYPES.SET_ERROR,
  payload: error
});

/**
 * Inizia la registrazione di un evento
 */
export const recordEventStart = () => ({
  type: GAMIFICATION_TYPES.RECORD_EVENT_START
});

/**
 * Evento registrato con successo
 */
export const recordEventSuccess = (result) => ({
  type: GAMIFICATION_TYPES.RECORD_EVENT_SUCCESS,
  payload: result
});

/**
 * Evento fallito
 */
export const recordEventFailure = (error) => ({
  type: GAMIFICATION_TYPES.RECORD_EVENT_FAILURE,
  payload: error
});

/**
 * Mostra il toast dei punti guadagnati
 */
export const showPointsToast = (pointsData) => ({
  type: GAMIFICATION_TYPES.SHOW_POINTS_TOAST,
  payload: pointsData
});

/**
 * Nasconde il toast dei punti
 */
export const hidePointsToast = () => ({
  type: GAMIFICATION_TYPES.HIDE_POINTS_TOAST
});

/**
 * Imposta la visibilità del modale (onboarding/daily)
 */
export const setModalVisible = (modalType, isVisible) => ({
  type: GAMIFICATION_TYPES.SET_MODAL_VISIBLE,
  payload: { modalType, isVisible }
});

/**
 * Pulisce il profilo gamification (logout)
 */
export const clearGamificationProfile = () => ({
  type: GAMIFICATION_TYPES.CLEAR_PROFILE
});

/**
 * Avvia l'onboarding a step per genitori/gift
 */
export const startStepOnboarding = () => ({
  type: GAMIFICATION_TYPES.START_STEP_ONBOARDING
});

/**
 * Passa allo step successivo dell'onboarding
 */
export const nextStepOnboarding = () => ({
  type: GAMIFICATION_TYPES.NEXT_STEP_ONBOARDING
});

/**
 * Termina l'onboarding a step
 */
export const endStepOnboarding = () => ({
  type: GAMIFICATION_TYPES.END_STEP_ONBOARDING
});

